import { jsx } from "react/jsx-runtime";
import RoiCalc from "@zg-rentals/rg-widgets-roi-calc";
const RentalRoiCalculatorBlock = {
  Component: ({
    attrs
  }) => {
    const {
      heading,
      subheading,
      itc,
      t
    } = attrs;
    const defaultValues = {
      heading,
      subheading,
      itc,
      t
    };
    return /* @__PURE__ */ jsx(RoiCalc, { ...defaultValues });
  },
  metadata: {
    version: "1.0",
    name: "zg-rentals/rg-widgets-roi-calc",
    title: "ZG ROI Calculator",
    description: "Calculate ROI on rental property to see the gross yield, cap rate, one-year cash return and annual return on investment.",
    icon: "calculators",
    keywords: ["roi", "rental", "calculator"],
    supports: {
      customClassName: false,
      html: false
    },
    category: "widgets",
    attributes: {
      heading: {
        type: "string",
        default: "Rental Property ROI Calculator"
      },
      subheading: {
        type: "string",
        default: "Calculate your potential return on investment."
      },
      itc: {
        type: "string"
      },
      t: {
        type: "string"
      }
    }
  }
};
export {
  RentalRoiCalculatorBlock as default
};
